import useSWR from 'swr';
import fetchDataService from '../services/fetchDataService';

export function useProductionCycles(tokenData:any, requestData:any){
  const {company} = requestData;
  const url = '/manufacturing/get-cycles';
  const fetcher = ([cachedUrl, cacheCompany, csrfTokenId]: any[]) => 
    fetchDataService.post(
      cachedUrl, 
      tokenData.key, 
      {...requestData, company: cacheCompany, csrfToken: csrfTokenId}
    );

  const {data, error, isLoading} = useSWR(
    ()=>(tokenData?.key && company) ? [url, company, tokenData.token.uid] : null, 
    fetcher, 
    {keepPreviousData:true}
  );
  return {
    data,
    error,
    isLoading
  }
}

export function useProductionCycle(tokenData:any, requestData:any){
  const {cycle_uid, company_uid} = requestData;
  const url = '/manufacturing/get-cycle';
  const fetcher = ([cachedUrl, cacheCompanyUid, csrfTokenId]: any[]) => {
    const extractedCycleUid = cachedUrl.split('/').pop();
    return fetchDataService.post(
      url, 
      tokenData.key, 
      {...requestData, cycle_uid: extractedCycleUid, company_uid: cacheCompanyUid, csrfToken: csrfTokenId}
    );
  };

  const {data, error, isLoading, mutate} = useSWR(
    ()=>(tokenData?.key && cycle_uid) ? [`${url}/${cycle_uid}`, company_uid, tokenData.token.uid] : null, 
    fetcher,
    {keepPreviousData: true}
  );
  return {
    data,
    error,
    mutate,
    isLoading
  }
}

export function useProductionCycleLogs(tokenData:any, requestData:any){
  const {cycle_id, start_date, end_date} = requestData;
  const url = '/manufacturing/get-logs';
  const fetcher = ([cachedUrl, csrfTokenId, startDate, endDate]: any[]) => {
    const extractedCycleId = cachedUrl.split('/').pop();
    return fetchDataService.post(
      url, 
      tokenData.key, 
      {...requestData, cycle_id: extractedCycleId, start_date: startDate, end_date: endDate, csrfToken: csrfTokenId}
    );
  };

  const {data, error, isLoading, mutate} = useSWR(
    ()=>(tokenData?.key && cycle_id) ? [`${url}/${cycle_id}`, tokenData.token.uid, start_date, end_date] : null, 
    fetcher, 
    {keepPreviousData: true}
  );
  return {
    data,
    error,
    mutate,
    isLoading
  }
}

export function useCycleTraceability(tokenData:any, requestData:any){
  const {cycle_id} = requestData;
  const url = '/traceability/get-cycle-group';
  const fetcher = () => 
    fetchDataService.post(
      url, 
      tokenData.key, 
      {...requestData, cycle_id, csrfToken: tokenData.token.uid}
    );

  const {data, error, isLoading, mutate} = useSWR(
    ()=>(tokenData?.key && cycle_id) ? [`${url}/${cycle_id}`, tokenData.token.uid] : null, 
    fetcher, 
    {keepPreviousData: true}
  );
  return {
    links: data?.links || [],
    error,
    mutate,
    isLoading
  }
}

export function useTraceableGroups(tokenData:any, requestData:any){
  const {company} = requestData;
  const url = '/traceability/get-groups';
  const fetcher = () => 
    fetchDataService.post(
      url, 
      tokenData.key, 
      {...requestData, company_id: company, csrfToken: tokenData.token.uid}
    );

  const {data, error, isLoading, mutate} = useSWR(
    ()=>(tokenData?.key && company) ? [`${url}/${company}`, tokenData.token.uid] : null, 
    fetcher, 
    {keepPreviousData: true}
  );
  return {
    groups: data?.groups || [],
    error,
    mutate,
    isLoading
  }
}
